// ═══════════════════════════════════════════════════════════════════
//  composants/Field.js
//  Field
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../socle/theme";

export function Field({ label, children, full }) {
  return (
    <div style={{gridColumn:full?"1 / -1":"auto",display:"flex",flexDirection:"column",gap:5}}>
      <label style={{color:THEME.textMuted,fontSize:11,fontWeight:600}}>{label}</label>
      {children}
    </div>
  );
}
